/* ITAY-OVERRIDE: pdp-fold */
/* Loox serves its wall from a cross-origin iframe and blocks CORS, so the on-store
   review count cannot be read at runtime. Update this one number when it changes. */
var IC_REVIEW_COUNT = 111;
(function () {
  /* diamond tester: probe pen touching a loose stone */
  var ICON_TESTER = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
    + '<path d="M4.4 12.7h5.9l2.3 2.7-5.25 6.2-5.25-6.2 2.3-2.7z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
    + '<path d="M2.1 15.4h10.5" stroke="currentColor" stroke-width="1.3"/>'
    + '<g transform="translate(-0.4 0.55)">'
    +   '<path d="M20.5 1.67l1.8 1.86-7.55 7.3-1.8-1.86 7.55-7.3z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
    +   '<path d="M12.95 8.97l1.8 1.86-2.25 1.05.45-2.91z" fill="currentColor"/>'
    +   '<path d="M17.6 4.4l1.8 1.86" stroke="currentColor" stroke-width="1.4"/>'
    + '</g></svg>';
  var ICON_SPARKLE = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2.5l1.9 5.3 5.3 1.9-5.3 1.9L12 16.9l-1.9-5.3L4.8 9.7l5.3-1.9L12 2.5z" fill="currentColor"/><path d="M18.5 14.8l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9.9-2.4z" fill="currentColor" opacity=".65"/><path d="M5 15.2l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7.7-1.9z" fill="currentColor" opacity=".45"/></svg>';
  var ICON_MATERIALS = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2.4l8.4 4.3v10L12 21.6 3.6 16.7v-10L12 2.4z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M3.9 6.9L12 11.4l8.1-4.5M12 11.4v9.9" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M7.7 4.6l8.2 4.4" stroke="currentColor" stroke-width="1.3" opacity=".6"/></svg>';
  var ICON_MEDAL = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.2 2h7.6l-2.3 7.2h-3L8.2 2z" fill="currentColor" opacity=".5"/><circle cx="12" cy="15.3" r="6.2" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M12 11.8l1.05 2.2 2.35.33-1.7 1.68.4 2.36L12 17.24l-2.1 1.13.4-2.36-1.7-1.68 2.35-.33L12 11.8z" fill="currentColor"/></svg>';
  var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="9.6" width="18" height="11.4" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M2.2 6.4h19.6v3.2H2.2z" fill="currentColor" opacity=".55"/><path d="M12 6.4v14.6" stroke="currentColor" stroke-width="1.7"/><path d="M12 6.4S10.9 3 9 3a1.9 1.9 0 000 3.8h3zM12 6.4S13.1 3 15 3a1.9 1.9 0 010 3.8h-3z" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  var USP_WARRANTY = { icon: ICON_MEDAL, text: 'Lifetime warranty &amp; 14-day returns' };
  var USP_GIFTBOX  = { icon: ICON_GIFT,  text: 'Arrives in a premium gift box' };

  /* moissanite really does pass a diamond tester and is graded D-color / VVS1.
     CZ and plain-metal pieces do not, so they get a claim set that is true for them. */
  var USPS_MOISSANITE = [
    { icon: ICON_TESTER,  text: 'Passes the diamond tester in a lab' },
    { icon: ICON_SPARKLE, text: 'Real VVS1 &amp; D-Color' },
    USP_WARRANTY, USP_GIFTBOX
  ];
  var USPS_CZ = [
    { icon: ICON_SPARKLE, text: 'Everyday sparkle that gets noticed' },
    { icon: ICON_MATERIALS, text: 'Crafted from premium materials' },
    USP_WARRANTY, USP_GIFTBOX
  ];

  function uspSet() {
    var h1 = (document.querySelector('.product-details h1') || {}).textContent || '';
    // the H1 is the claim the customer reads, so it wins
    if (/\bCZ\b|cubic zirconia/i.test(h1)) return USPS_CZ;
    if (/moissanite/i.test(h1)) return USPS_MOISSANITE;
    // plain chain shapes carry no stones whatever the copy says elsewhere
    if (/cuban link|rope|franco|box chain|curb|figaro|snake|herringbone/i.test(h1)
        && !/iced|prong|vvs|tennis|cluster|diamond|halo|baguette/i.test(h1)) return USPS_CZ;
    var body = (document.querySelector('.product-details .accordion') || {}).textContent || '';
    if (/moissanite/i.test(body)) return USPS_MOISSANITE;
    return USPS_CZ;
  }

  function money(el) {
    if (!el) return null;
    var t = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }

  function savePill() {
    var media = document.querySelector('.product-information__grid slideshow-slide .product-media')
             || document.querySelector('.product-information__grid .product-media-container')
             || document.querySelector('.product-information__grid media-gallery');
    if (!media || media.querySelector('.ic-save-pill')) return;
    var root = document.querySelector('.product-details');
    if (!root) return;
    var diff = null;
    var s = money(root.querySelector('.price'));
    var r = money(root.querySelector('.compare-at-price'));
    if (s && r && r > s) diff = r - s;
    if (!diff) {
      var badge = root.querySelector('.ic-save-badge');
      var m = (badge ? badge.textContent : root.textContent || '').match(/saving\s*\$([\d.,]+)/i);
      if (m) diff = parseFloat(m[1].replace(/,/g, ''));
    }
    if (!diff || diff < 1) return;
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    var pill = document.createElement('div');
    pill.className = 'ic-save-pill';
    pill.textContent = 'SAVE $' + (Math.round(diff * 100) / 100).toFixed(2).replace(/\.00$/, '');
    media.appendChild(pill);
  }

  function usps() {
    var col = document.querySelector('.product-details .group-block-content');
    if (!col || col.querySelector('.ic-fold-usps')) return;
    var ul = document.createElement('ul');
    ul.className = 'ic-fold-usps';
    ul.innerHTML = uspSet().map(function (u) {
      return '<li>' + u.icon + '<span>' + u.text + '</span></li>';
    }).join('');
    var anchor = col.querySelector('.ic-sg__trigger') || col.querySelector('.globo-swatch-product-detail');
    if (anchor) col.insertBefore(ul, anchor); else col.appendChild(ul);
  }

  /* put the Size Guide link inside the size option's own label row,
     never on the colour row and never on "Stone Size" */
  function sizeGuide() {
    var trg = document.querySelector('.product-details .ic-sg__trigger');
    if (!trg || trg.closest('.ic-sg-host')) return;
    var legends = document.querySelectorAll('.product-details .globo-swatch-product-detail legend.name-option');
    var host = null;
    for (var i = 0; i < legends.length; i++) {
      var t = (legends[i].textContent || '').trim();
      if (/^(size|length)\s*:/i.test(t)) host = legends[i];
    }
    if (!host) return;
    if (!host.querySelector('.ic-sg-label')) {
      var wrap = document.createElement('span');
      wrap.className = 'ic-sg-label';
      while (host.firstChild) wrap.appendChild(host.firstChild);
      host.appendChild(wrap);
    }
    host.classList.add('ic-sg-host');
    host.appendChild(trg);
  }

  /* the review count next to the stars jumps to the review wall */
  function reviewJump() {
    var el = document.querySelector('.product-details .ic-rating-count, .rating-wl-wrap .ic-rating-count');
    if (!el || el.dataset.icJump) return;
    el.dataset.icJump = '1';
    el.style.cursor = 'pointer';
    el.setAttribute('role', 'link');
    el.setAttribute('tabindex', '0');
    var go = function (e) {
      if (e) e.preventDefault();
      var t = document.querySelector('.ic-reviews-head') || document.querySelector('#looxReviews, #looxReviewsFrame, [id*="loox_review"]');
      if (!t) return;
      var y = t.getBoundingClientRect().top + window.pageYOffset - 70;
      var from = window.pageYOffset;
      try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
      // some browsers no-op on smooth scrolling; land it anyway
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - from) < 20) {
          // the theme sets `scroll-behavior: smooth`, so a plain scrollTo animates too;
          // force an un-animated jump when the animation never ran
          try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (err) { window.scrollTo(0, y); }
        }
      }, 450);
    };
    el.addEventListener('click', go);
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
  }

  /* Loox renders its wall inside a cross-origin iframe, so its own "111 reviews"
     label cannot be edited. This header sits above it and names both numbers,
     so the count at the top of the page and the count on the wall stop contradicting. */
  function reviewsHeader() {
    var wall = document.querySelector('#looxReviews, [id*="loox_review"]');
    if (!wall || document.querySelector('.ic-reviews-head')) return;
    var box = document.createElement('div');
    box.className = 'ic-reviews-head';
    box.innerHTML =
      '<div class="ic-reviews-head__stars">★★★★★</div>' +
      '<div class="ic-reviews-head__title">Loved by 35,562 happy customers worldwide</div>' +
      '<div class="ic-reviews-head__sub">4.8/5 average &middot; ' + IC_REVIEW_COUNT + ' verified photo reviews on this store</div>';
    wall.parentNode.insertBefore(box, wall);
  }

  function gwp() {
    var el = document.querySelector('.product-details .ic-gwp');
    if (!el || el.dataset.icCompact) return;
    var txt = (el.innerText || '').replace(/\s+/g, ' ').trim();
    if (/free cuban link/i.test(txt)) {
      el.innerHTML = '<span style="font-size:1rem">🎁</span><span><strong>Spend $500 → FREE Cuban Link Chain</strong> ($99 value, added at checkout)</span>';
      el.dataset.icCompact = '1';
    }
  }

  function run() { try { savePill(); usps(); sizeGuide(); reviewJump(); reviewsHeader(); gwp(); } catch (e) {} }

  if (document.body && document.querySelector('.product-details')) run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('load', run);
  new MutationObserver(function () { run(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* sticky mobile ATC */
(function () {
  function realBtn() {
    return document.querySelector('.product-details .buy-buttons-block button[name="add"], .product-details .buy-buttons-block button, .product-details .buy-buttons-block [type="submit"]');
  }
  function build() {
    if (window.innerWidth > 749) return;
    var host = document.querySelector('.product-details .buy-buttons-block');
    if (!host || document.querySelector('.ic-sticky-atc')) return;
    var name = (document.querySelector('.product-details h1')?.textContent || '').trim();
    var price = (document.querySelector('.product-details .price')?.textContent || '').trim();
    var cmp = (document.querySelector('.product-details .compare-at-price')?.textContent || '').trim();
    var bar = document.createElement('div');
    bar.className = 'ic-sticky-atc';
    bar.innerHTML =
      '<div class="ic-sticky-atc__meta">' +
        '<span class="ic-sticky-atc__name"></span>' +
        '<span class="ic-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="ic-sticky-atc__btn">ADD TO CART</button>';
    bar.querySelector('.ic-sticky-atc__name').textContent = name;
    var p = bar.querySelector('.ic-sticky-atc__price');
    p.textContent = price;
    if (cmp && cmp !== price) { var s = document.createElement('s'); s.textContent = cmp; p.appendChild(s); }
    bar.querySelector('.ic-sticky-atc__btn').addEventListener('click', function () {
      var b = realBtn();
      if (b) b.click();
      else host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    document.body.appendChild(bar);
    var sync = function () {
      var r = host.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0 || r.top > window.innerHeight);
    };
    sync();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        bar.classList.toggle('is-on', !es[0].isIntersecting);
      }, { threshold: 0 }).observe(host);
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    setInterval(sync, 400);
  }
  document.addEventListener('DOMContentLoaded', build);
  window.addEventListener('load', build);
  setTimeout(build, 900);
})();
